export const COMMUNITY_API_PREFIX = '/api/community/community'
export const COMMENT_API_PREFIX = '/api/comment/comments'
export const INNER_API = process.env.SIO_INNER_HOST
